<template>
  <div class="switch-user">
    <NavBtn
      :on-click="back"
    />
    <div class="title">切换用户</div>
    <div class="mobile double-row">
      <div><span class="name">手机号码：</span><input type="tel" v-model='telePhone' maxlength="11"></div>
      <div><span class="name">验证码：</span><input type="tel" maxlength="4" v-model='teleCode'><span class="send-code" :class="{'disabled': isdisabled}" @click="getCode()" v-text="getCodeText"></span></div>
    </div>
    <div class="btn-middle shadow submit" @click='login()'>登录</div>
  </div>
</template>
<style lang="scss" scoped>
@media only screen and (device-height: 812px) {
    .switch-user{
      padding-top: 24px !important;
    }
  }
  .switch-user {
    background-color: #3A4E92;
    height: 100%;
    padding-top: 34px;

    .back {
      position: absolute;
      top: 16px;
      left: 20px;
      width: 40px;
      height: 40px;
      background: #342F74;
      box-shadow: 0 3px 5px 0 #36308E;
      border-radius: 50%;
    }

    .title {
      text-align: center;
      font-size: 18px;
      color: #FFFFFF;
      margin-bottom: 30px;

      @include regular();
    }

    .mobile {
      margin: 0 auto 40px;
      overflow: hidden;

      input {
        font-size: 16px;
        color: #3A3A3A;
        width: 150px;
        border: none;
        outline: medium;

        @include semibold();
      }

      .name {
        font-size: 13px;
        color: #3A3A3A;
        display: inline-block;
        width:70px;

        @include regular();
      }

      .send-code {
        float: right;
        margin-right: 15px;
        font-size: 13px;
        color: #403A92;
        text-decoration: underline;

        @include regular();

        &.disabled {
          color: #c5c4c3;
        }
      }
    }

    .submit {
      margin: 0 auto;
    }
  }
</style>

<script>
import $toast from '../common/Toast.js'
import { mapActions, mapState } from 'vuex'
import { URI_GET_PHONECODE, URI_MOBLIE_LOGIN } from '@/store/modules/user/type'
export default {
  data () {
    return {
      getCodeLock: false,
      isdisabled: false,
      getCodeText: '获取验证码',
      code_timer: 0,
      telePhone: '',
      teleCode: ''
    }
  },
  computed: {
    ...mapState({
      getCodeSuccess: state => state.user.getCodeSuccess
    })
  },
  methods: {
    ...mapActions({
      getMoblieCode: URI_GET_PHONECODE,
      userLogin: URI_MOBLIE_LOGIN
    }),
    back () {
      this.$router.push('/user')
    },

    resetCounterBtn () {
      this.getCodeLock = false
      this.getCodeText = '获取验证码'
      this.isdisabled = false
    },

    async getCode () {
      if (this.getCodeLock) return
      let s = 60
      let mobile = this.telePhone
      let reg = 11 && /^((12|13|14|15|16|17|18|19)[0-9]{1}\d{8})$/ // 手机号正则验证
      if (!mobile) {
        $toast.show('请输入手机号', '', 2000)
        return
      }
      if (!reg.test(mobile)) { // 手机号不合法
        $toast.show('您输入的手机号码不合法, 请重新输入', '', 2000)
        return
      }
      this.getCodeLock = true
      this.isdisabled = true
      this.code_timer = setInterval(() => {
        s--
        if (s === 0) {
          this.resetCounterBtn()
          this.stop()
        } else {
          this.getCodeText = '已发送' + '(' + s + 's' + ')'
        }
      }, 1000)

      const res = await this.getMoblieCode({
        mobile
      })
      if (res && res.status === 200) {
        if (!this.getCodeSuccess) {
          this.resetCounterBtn()
          this.stop()
        }
      }
    },
    stop () {
      if (this.code_timer) clearInterval(this.code_timer)
    },
    async login () {
      let mobile = this.telePhone
      const reg = /^\d{11}$/
      let result = reg.exec(mobile)
      if (!mobile || !result) {
        $toast.show('请输入正确的手机号', '', 2000)
        return
      }
      let code = this.teleCode
      let cReg = /^\d{4}$/
      if (!code || !cReg.test(code)) {
        $toast.show('请输入正确的验证码', '', 2000)
        return
      }
      const res = await this.userLogin({
        mobile,
        code
      })
      if (res && res.payload === 'ok') {
        $toast.show('登录成功', 1000)
        setTimeout(() => {
          $router.push('/')
        }, 1000)
      } else {
        $toast.show(res.data.err_msg, 1000)
      }
    }
  }
}
</script>

